<template>
  <div>
    <v-btn                      
      color="blue-grey"
      class="white--text"
      @click="$refs.mediaUpload.click()"
      :disabled="checkDisable"      
    >
      {{title ? title : 'Upload'}}
      <v-icon
        right
        dark
      >
        mdi-cloud-upload
      </v-icon>
    </v-btn>
    <div class="mt-3">
      <div v-if="tmpImages.length > 0">
        <v-col
          v-for="(img, index) in tmpImages"
          :key="index"
          class="d-flex child-flex"
          cols="12" sm="12" md="2" lg="2"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card
              flat
              tile
              class="d-flex"                              
              :elevation="hover ? 16 : 2"
            >
              <v-img                                  
                :src="img.url"
                :lazy-src="img.url"                                  
                class="grey lighten-2"
                aspect-ratio="1"
              ></v-img>
              <v-overlay absolute>
                <v-btn dark icon @click="deleteImage(index)">
                  <v-icon dark color="red">cancel</v-icon>
                </v-btn>
              </v-overlay>
            </v-card>
          </v-hover>
        </v-col>
      </div>
      <v-row v-if="tmpFiles.length > 0" >
        <v-col cols="12" sm="12" md="2" lg="2" v-for="(item, index) in tmpFiles" :key="index" align="center">                   
          <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
            <v-img
                width="67" height="85"
                src="/static/img/pdf.png"
                aspect-ratio="1"
              ></v-img>
          </a>                                                                                                               
          <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
            <v-img
                width="67" height="85"
                src="/static/img/ppt.png"
              ></v-img>
          </a>
          <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
            <v-img
                width="67" height="85"
                src="/static/img/doc.png"
              ></v-img>
          </a>
          <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
            <v-img
                width="67" height="85"
                src="/static/img/text.png"
              ></v-img>
          </a>                        
          <v-btn dark icon @click="deleteFile(index)">
            <v-icon dark color="red">cancel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <!-- File Upload -->
    <input
      type="file"
      name="media"
      style="display: none"
      ref="mediaUpload"
      id="fileToUpload"
      accept="image/*, .pdf, .ppt, .txt, .doc, .docx"
      @change="prepareUpload"
      :multiple="multiple || false"
    />
  </div>
</template>
<script>
import utils from '@/utils';
export default {
  name: 'CustomFileUpload',
  data () {
    return {
      uploadFiles: [],
      deleteObjectKeys: [],
      tmpImages: [],
      tmpFiles: [],
      actualMedias: []
    }
  },
  props: ['refresh', 'multiple', 'title'],
  watch: {
    refresh: function(newRefresh) {
      this.resetUpload()
    }
  },
  computed: {
    checkDisable() {
      if (!this.multiple) {
        return this.actualMedias.length > 0
      }
      return false
    }
  },
  methods: {
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let mediaType = element.type.split('/')[0];
        // let fileType = element.name.split('.')[1];
        if (mediaType === 'image') {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buff = e.target.result;
            let file = utils.func.dataURLtoFile(buff, element.name);
            this.actualMedias.push(file);
            this.tmpImages.push({
              url: buff,
              src: buff,
              name: element.name
            })
            this.updateMedias()
          };
          // reset the input
          e.target.value = '';
        } else {
          this.tmpFiles.push(element);
          this.actualMedias.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
          this.updateMedias()
        }
      });
    },
    deleteImage(imgIndex) {
      let filename = this.tmpImages[imgIndex].name
      this.deleteObjectKeys.push(filename)
      this.tmpImages.splice(imgIndex, 1)
      let mediaIndex = this.actualMedias.findIndex(item => item.name === filename)
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1)
      this.updateMedias()
    },
    deleteFile(fileIndex) {
      let fileName = ''
      if (this.tmpFiles[fileIndex].name) {
        fileName = this.tmpFiles[fileIndex].name;
        this.deleteObjectKeys.push(fileName)
      }
      this.tmpFiles.splice(fileIndex, 1)
      let mediaIndex = this.actualMedias.findIndex(item => item.name === fileName)
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1)
      this.updateMedias()
    },
    updateMedias() {
      this.$emit('setMedias', this.actualMedias)
    },
    resetUpload() {
      this.uploadFiles = []
      this.deleteObjectKeys = []
      this.tmpImages = []
      this.tmpFiles = []
      this.actualMedias = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomFileUpload.vue?1e6685be